export const RouterView = {
    render(mount) {
        return mount('router-view')
    }
};
